import theme from 'common/theme'
import styled from 'styled-components'

const ContainerDivider = styled.div`
  display: flex;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  background: ${(props) => props.color || `${theme.colors.orange}`};
  border-radius: ${(props) => props.borderRadius};
`

interface DividerProps {
  width?: string
  height?: string
  margin?: string
  color?: string
  borderRadius?: string | number
}

function Divider({
  width = '91px',
  height = '4px',
  margin = '0',
  color,
  borderRadius = '0 0 30px 30px',
}: DividerProps): JSX.Element {
  return (
    <ContainerDivider
      width={width}
      height={height}
      margin={margin}
      color={color}
      borderRadius={borderRadius}
      data-testid="divider-component"
    />
  )
}

export default Divider
